var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("mode-info " + _vm.design)},[_c('i',{staticClass:"fas fa-info-circle"}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }